import defaultProfileImage from '../assets/images/default-profile.png';

export const DEFAULT_PROFILE_IMAGE = defaultProfileImage;

export const photoSource = (photo) => {
    if (typeof photo === 'string') return photo.trim();
    if (!photo || typeof photo !== 'object') return '';
    return photo.url || photo.imageUrl || photo.src || '';
};

export const getModelPhotoSources = (model) => {
    const photos = Array.isArray(model?.photos)
        ? model.photos.map(photoSource).filter(Boolean)
        : [];
    const image = photoSource(model?.image);
    return photos.length ? photos : (image ? [image] : []);
};

export const hasModelPhoto = (model) => getModelPhotoSources(model).length > 0;

export const getModelPhotos = (model) => {
    const photos = getModelPhotoSources(model);
    return photos.length ? photos : [DEFAULT_PROFILE_IMAGE];
};

export const getModelPhoto = (model) => getModelPhotos(model)[0];
